function initGrid() {
  const viewBtns = document.querySelectorAll(".cus-collection-viewBtn");
  const productGrid = document.querySelector("#ProductGridContainer");
  const productGrid2024 = document.querySelector("#ProductGridContainer2024");
  const gridItems = document.querySelectorAll(".grid__item");
  const collectionHero = document.querySelector(".collection-hero");

  function clearPixels() {
    const contenedoresTitle = document.querySelectorAll(".cus-title-container");

    contenedoresTitle.forEach((contenedor) => {
      const title = contenedor.querySelector(".cus-spliced-title");

      if (!title) return;

      const atag = title.children[0];

      atag.style.width = "";
      atag.style.overflow = "";
      atag.style.textOverflow = "";
      atag.style.whiteSpace = "";
    });
  }

  function breakTitle() {
    // console.log("break");
    const contenedoresTitle = document.querySelectorAll(".cus-title-container");

    contenedoresTitle.forEach((contenedor) => {
      const title = contenedor.querySelector(".cus-spliced-title");

      if (!title) return;

      const containerWidth = contenedor.clientWidth;

      const atag = title.children[0];

      atag.style.width = containerWidth + "px";
      atag.style.overflow = "hidden";
      atag.style.textOverflow = "ellipsis";
      atag.style.whiteSpace = "nowrap";
      atag.style.lineHeight = "normal";
    });
  }

  if (window.innerWidth < 750) {
    clearPixels();

    if (productGrid2024) {
      productGrid2024.classList.add("mobile-view-1__2024");
    } else {
      productGrid.classList.add("mobile-view-1");
    }

    gridItems.forEach((item, index) => {
      if (index % 3 == 0) {
        item.classList.add("cus-grid-view");
      }
    });

    document.addEventListener("collection:infinitescroll", () => {
      clearPixels();

      if (productGrid2024) {
        if (productGrid2024.classList.contains("mobile-view-1__2024")) {
          const gridItems = document.querySelectorAll(".grid__item");
          gridItems.forEach((item, index) => {
            if (index % 3 == 0) {
              item.classList.add("cus-grid-view");
            }
          });
        }
      } else {
        if (productGrid.classList.contains("mobile-view-1")) {
          const gridItems = document.querySelectorAll(".grid__item");
          gridItems.forEach((item, index) => {
            if (index % 3 == 0) {
              item.classList.add("cus-grid-view");
            };
          });
        }
      }
    });

  }

  breakTitle();

  viewBtns.forEach((viewBtn, i) => {
    viewBtn.addEventListener("click", () => {
      clearPixels();
      if (window.innerWidth < 750) {
        const view1 = viewBtn.querySelector(".cus-collection-view-1-mobile");
        const view2 = viewBtn.querySelector(".cus-collection-view-2-mobile");

        if (productGrid2024) {
          if (productGrid2024.classList.contains("mobile-view-1__2024")) {
            view1.classList.toggle("cus-inactive");
            view2.classList.toggle("cus-inactive");
            productGrid2024.classList.remove("mobile-view-1__2024");
            productGrid2024.classList.add("mobile-view-2__2024");
            
            gridItems.forEach((item, index) => {
              if (index % 3 == 0) {
                item.classList.remove("cus-grid-view");
              }
            });
          } else {
            view1.classList.toggle("cus-inactive");
            view2.classList.toggle("cus-inactive");
            productGrid2024.classList.remove("mobile-view-2__2024");
            productGrid2024.classList.add("mobile-view-1__2024");
            
            gridItems.forEach((item, index) => {
              if (index % 3 == 0) {
                item.classList.add("cus-grid-view");
              }
            });
          }

        } else {
          if (productGrid.classList.contains("mobile-view-1")) {
            view1.classList.toggle("cus-inactive");
            view2.classList.toggle("cus-inactive");
            productGrid.classList.remove("mobile-view-1");
            productGrid.classList.add("mobile-view-2");
            
            gridItems.forEach((item, index) => {
              if (index % 3 == 0) {
                item.classList.remove("cus-grid-view");
              }
            });
          } else {
            view1.classList.toggle("cus-inactive");
            view2.classList.toggle("cus-inactive");
            productGrid.classList.remove("mobile-view-2");
            productGrid.classList.add("mobile-view-1");
            
            gridItems.forEach((item, index) => {
              if (index % 3 == 0) {
                item.classList.add("cus-grid-view");
              }
            });
          }
        } 
      } else {
        const viewText = viewBtn.querySelector(".cus-collection-view__text");
        const view2 = viewBtn.querySelector(".cus-collection-view-2");
        const view4 = viewBtn.querySelector(".cus-collection-view-4");

        if (productGrid2024) {
          if (viewText.innerText === "VISTA 4") {
            viewText.innerText = "VISTA 2";
            view2.classList.remove("cus-inactive");
            view4.classList.add("cus-inactive");
            productGrid2024.classList.remove("desktop-view-4__2024");
            productGrid2024.classList.add("desktop-view-2__2024");

          } else {
            viewText.innerText = "VISTA 4";
            view4.classList.remove("cus-inactive");
            view2.classList.add("cus-inactive");
            productGrid2024.classList.remove("desktop-view-2__2024");
            productGrid2024.classList.add("desktop-view-4__2024");
          }

        } else {
          
          if (viewText.innerText === "VISTA 4") {
            viewText.innerText = "VISTA 2";
            view2.classList.remove("cus-inactive");
            view4.classList.add("cus-inactive");
            productGrid.classList.remove("desktop-view-4");
            productGrid.classList.add("desktop-view-2");
          } else {
            viewText.innerText = "VISTA 4";
            view4.classList.remove("cus-inactive");
            view2.classList.add("cus-inactive");
            productGrid.classList.remove("desktop-view-2");
            productGrid.classList.add("desktop-view-4");
          }
        }
      }
  
      breakTitle();
    });
  })
}

// JS +Colores en colecciones deshabilitado por Brownie Spain

// function showColorSwatches () {
//   const productCardsCollection = document.querySelectorAll("div[data-parentIdentifier]");
//   console.log(productCardsCollection[0].dataset.parentidentifier)
//   productCardsCollection.forEach((card) => {
//     const showSwatchesBtn = card.querySelector(".showSwatchesBtn");
//     const priceContainerSibling = card.querySelector(".price__container");
//     const hideSwatchesBtn = card.querySelector('.hideSwatchesBtn');
//     if (showSwatchesBtn) {
//       showSwatchesBtn.addEventListener("click", () => {
//         const swatchesContainer = document.querySelector(`div[data-identifier="product-${card.dataset.parentidentifier}"]`);
//         swatchesContainer.classList.toggle("cus-inactive");
//         showSwatchesBtn.classList.toggle("cus-inactive");
//         priceContainerSibling.classList.toggle("cus-inactive");
//         hideSwatchesBtn.classList.toggle("cus-inactive");
//       });
  
//       hideSwatchesBtn.addEventListener("click", () => {
//         const swatchesContainer = document.querySelector(`div[data-identifier="product-${card.dataset.parentidentifier}"]`);
//         swatchesContainer.classList.toggle("cus-inactive");
//         showSwatchesBtn.classList.toggle("cus-inactive");
//         priceContainerSibling.classList.toggle("cus-inactive");
//         hideSwatchesBtn.classList.toggle("cus-inactive");
//       });
//     }
//   });
// }

function loadSubcollections() {

  const links = document.querySelectorAll('.cus-linksToSort');
  let subcollections = [];

  links.forEach(link => {
    subcollections.push({
      title: link.dataset.title,
      link: link.dataset.link
    });
  });

  subcollections.sort((a, b) => {
    if (a.title > b.title) {
      return 1;
    }
    if (a.title < b.title) {
      return -1;
    }
    return 0;
  });
  
  const wrapperMobile = document.querySelector('.cus-collection-subnavigation.cus-desktop-hidden .cus-collection-subnavigation-wrapper');
  const wrapperDesktop = document.querySelector('.cus-collection-subnavigation.cus-mobile-hidden .cus-collection-subnavigation-wrapper');
  
  if (window.innerWidth < 750) {
    subcollections.forEach(subcollection => {
      
      const li = document.createElement('li');
      li.classList.add('cus-collection-subnavigation__link', 'cus-collection-subnavigation__link-mobile');
      const a = document.createElement('a');
      a.href = subcollection.link;
      a.textContent = subcollection.title;
      li.appendChild(a);
      wrapperMobile.appendChild(li);
    });
  } else {
    subcollections.forEach(subcollection => {

      const li = document.createElement('li');
      li.classList.add('cus-collection-subnavigation__link', 'cus-collection-subnavigation__link-mobile');
      const a = document.createElement('a');
      a.href = subcollection.link;
      a.textContent = subcollection.title;
      li.appendChild(a);
      wrapperDesktop.appendChild(li);
    });
  }

}

function parentCollectionCheck() {
  const current_url = window.location.href;
  const subnavigationLinksDesktop = document.querySelectorAll(".cus-collection-subnavigation__link-desktop a");
  const subnavigationLinksMobile = document.querySelectorAll(".cus-collection-subnavigation__link-mobile a");

  subnavigationLinksDesktop.forEach((link) => {
    const linkUrl = link.href;
    if (current_url === linkUrl) {
      link.parentElement.classList.add("cus-collection-subnavigation__link-active");
    } else {
      link.parentElement.classList.add("cus-collection-subnavigation__link-disabled");
    }
  });

  subnavigationLinksMobile.forEach((link) => {
    const linkUrl = link.href;
    if (current_url === linkUrl) {
      link.parentElement.classList.add("cus-collection-subnavigation__link-active");
    } else {
      link.parentElement.classList.add("cus-collection-subnavigation__link-disabled");
    }
  });

}

function infinteScroll(){
  const targetObserver = document.querySelector(".pagination-wrapper");
  console.log("targetObserver", targetObserver)
  if (!targetObserver) return;

  const options = {
    root: null,
    rootMargin: "100px",
  };

  const observer = new IntersectionObserver( (entries, observer) => {
    entries.forEach(async (entry) => {
      if (entry.isIntersecting) {
        

        const paginationElement = entry.target;
        
        const nextLink = paginationElement.getAttribute("data-url");
        if (nextLink.charAt(0) === "&") return

        const newHtml = await fetch(nextLink);

        const newDocument = new DOMParser().parseFromString(await newHtml.text(), "text/html");

        const gridElements = newDocument.querySelectorAll(".product-grid .grid__item");
        const newPaginationElement = newDocument.querySelector(".collection .pagination-wrapper");
        // console.log("newPagination", newPaginationElement)
        // console.log("grid elements", gridElements)

        if (!gridElements) return;

        const gridContainer = document.querySelector("#product-grid");

        paginationElement.remove();

        gridContainer.append(...gridElements);
        gridContainer.parentElement.append(newPaginationElement);

        document.dispatchEvent(new CustomEvent("collection:infinitescroll"));
        // showColorSwatches();
        initPLP2024Carousels();

        if (entry.time > 5000) {
          SmartWishlistScripts();
          
        }

        setTimeout(() => {
          console.log("timeout nueva paginacion");
          infinteScroll();
        }, 1000);
      }
    });
  }, options);
  
  if (targetObserver) observer.observe(targetObserver);
}

// showColorSwatches();
infinteScroll();
initGrid();

const displayOrientation = (initial) => {
  const screenOrientation = screen.orientation.type;
  const orientation = `The orientation of the screen is: ${screenOrientation}`;

  if(!initial){
    initGrid();
  }

  return screenOrientation;
};

if (screen && screen.orientation !== null) {
  try {
    window.screen.orientation.onchange = displayOrientation;
    displayOrientation(true);
  }
  catch (e) { console.log(e) }
}

function initPLP2024Carousels() {
  const plp2024carousels = document.querySelectorAll('.swiper-collection-2024');

  if (!plp2024carousels.length) return;

  plp2024carousels.forEach(carousel => {
      const nextEl = carousel.querySelector('.swiper-button-next');
      const prevEl = carousel.querySelector('.swiper-button-prev');

      const swiper = new Swiper(carousel, {
          loop: true,
          navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
          },
      });
  });

}

initPLP2024Carousels();

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    initGrid();
    // showColorSwatches();
    infinteScroll();
    initPLP2024Carousels();
  });
}

loadSubcollections();
parentCollectionCheck();
